import { Home, Sdg1, Sdg2, Sdg5, Sdg6, Sdg10, Sdg12, Sdg14, Sdg15, FrameworkAgendaSection, Annex } from './views/AppViews'
import React, { useEffect, useState, useRef} from "react";
import {
    Route,
    useLocation,
    Routes,
    HashRouter,
} from "react-router-dom";
import "./App.css";
import "./2023.css";
import NavMain from "./components/NavMain"
import NavEx from "./components/NavEx"


function AnimatedSwitch() {
    const location = useLocation();

    const [displayLocation, setDisplayLocation] = useState(location);
    const [order, setOrder] = useState(1);
    const [direction, setDirection] = useState('prev');
    const [transitionStage, setTransistionStage] = useState("fadeIn");

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    const prevOrder = usePrevious(order);

    useEffect(() => {
        document.getElementById('loader').classList.remove('loading');
        if ((location !== displayLocation)) setTransistionStage("fadeOut");
        if (prevOrder > order) {
            setDirection("next")
        } else if ((prevOrder < order)) {
            setDirection("prev")
        }

    }, [location, displayLocation, order, prevOrder]);


    return (
        <div>
            <div className="modal fade" id="copyrightModal" tabIndex="-1" aria-labelledby="copyrightModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
<p>التنويه المطلوب:<br/> منظمة الأغذية والزراعة. 2023 . <i>تتبع التقدم المحرز في مؤشرات أهداف التنمية المستدامة المتعلقة بالأغذية والزراعة</i> 2023. روما<br/><a href="https://doi.org/10.4060/cc7088ar" target="_blank" rel="noreferrer">https://doi.org/10.4060/cc7088ar</a></p>
<p>المسميات المستخدمة في هذا المنتج الإعلامي وطريقة عرض المواد الواردة فيه لا تعبر عن أي رأي كان خاص بمنظمة الأغذية والزراعة للأمم المتحدة (المنظمة) بشأن الوضع القانوني أو الإنمائي لأي بلد، أو إقليم، أو مدينة، أو منطقة، أو لسلطات أي منها، أو بشأن تعيين حدودها وتخومها. وتشير الخطوط المتقطعة على الخرائط إلى الحدود التقريبية التي قد لا يكون هناك اتفاق كامل بشأنها بعد ولا تعني الإشارة إلى شركات أو منتجات محددة لمصنعين، سواء كانت مشمولة ببراءات الاختراع أم لا، أنها تحظى بدعم أو تزكية المنظمة تفضيلا لها على أخرى ذات طابع مماثل لم يرد ذكرها.</p>
<p className="mb-1">ISBN 978-92-5-138096-3<br/> ©ﻣﻨﻈﻤﺔ اﻷﻏﺬﯾﺔ واﻟﺰراﻋﺔ ، 2023</p>
                            <span dir="rtl"><img dir="rtl" className="copyright-modal-img mb-4" src={require('./images/copyright.png').default} alt="copyright" /></span>
<p>بعض الحقوق محفوظة. هذا المُصنَّف متاح وفقا لشروط الترخيص العام للمشاع الإبداعي نسب المصنف - غير تجاري - المشاركة بالمثل 3.0 لفائدة المنظمات الحكومية الدولية</p>
<p>(CC BY-NC-SA 3.0 IGO; <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/igo/deed.ar" target="_blank" rel="noreferrer">https://creativecommons.org/licenses/by-nc-sa/3.0/igo/deed.ar</a>). </p>
<p>بموجب أحكام هذا الترخيص، يمكن نسخ هذا العمل، وإعادة توزيعه، وتكييفه لأغراض غير تجارية، بشرط التنويه بمصدر العمل على نحو مناسب. وفي أي استخدام لهذا العمل، لا ينبغي أن يكون هناك أي اقتراح بأن المنظمة تؤيد أي منظمة، أو منتجات، أو خدمات محددة. ولا يسمح باستخدام شعار المنظمة. وإذا تم تكييف العمل، فإنه يجب أن يكون مرخصا بموجب نفس ترخيص المشاع الإبداعي أو ما يعادله. وإذا تم إنشاء ترجمة لهذا العمل، فيجب أن تتضمن بيان إخلاء المسؤولية التالي بالإضافة إلى التنويه المطلوب: «لم يتم إنشاء هذه الترجمة من قبل منظمة الأغذية والزراعة للأمم المتحدة. والمنظمة ليست مسؤولة عن محتوى أو دقة هذه الترجمة. وسوف تكون الطبعة [طبعة اللغة] الأصلية هي الطبعة المعتمدة”. </p>
<p> تتم تسوية النزاعات الناشئة بموجب الترخيص التي لا يمكن تسويتها بطريقة ودية عن طريق الوساطة والتحكيم كما هو وارد في المادة 8 من الترخيص، باستثناء ما هو منصوص عليه بخلاف ذلك في هذا الترخيص. وتتمثل قواعد الوساطة المعمول بها في قواعد الوساطة الخاصة بالمنظمة العالمية للملكية الفكرية <a href="http://www.wipo.int/amc/en/mediation/rules" target="_blank" rel="noreferrer">http://www.wipo.int/amc/en/mediation/rules</a>، وسيتم إجراء أي تحكيم طبقا  لقواعد التحكيم الخاصة بلجنة الأمم المتحدة للقانون التجاري الدولي (UNCITRAL).</p>
<p><b>مواد الطرف الثالث</b>. يتحمل المستخدمون الراغبون في إعادة استخدام مواد من هذا العمل المنسوب إلى طرف ثالث، مثل الجداول، والأشكال، والصور، مسؤولية تحديد ما إذا كان يلزم الحصول على إذن لإعادة الاستخدام والحصول على إذن من صاحب حقوق التأليف والنشر. وتقع تبعة المطالبات الناشئة عن التعدي على أي مكون مملوك لطرف ثالث في العمل على عاتق المستخدم وحده. </p>
<p><b>المبيعات، والحقوق، والترخيص</b>. يمكن الاطلاع على منتجات المنظمة الإعلامية على الموقع الشبكي للمنظمة (<a href="http://www.fao.org/publications/ar" target="_blank" rel="noreferrer">http://www.fao.org/publications/ar</a>) ويمكن شراؤها من خلال <a href="mailto:publications-sales@fao.org" target="_blank" rel="noreferrer">publications-sales@fao.org</a>. وينبغي تقديم طلبات الاستخدام التجاري عن طريق: <a href="http://www.fao.org/contact-us/licence-request" target="_blank" rel="noreferrer">www.fao.org/contact-us/licence-request</a>. وينبغي تقديم الاستفسارات المتعلقة بالحقوق والترخيص إلى: <a href="mailto:copyright@fao.org" target="_blank" rel="noreferrer">copyright@fao.org</a>.</p>

      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal">نهاية</button>
      </div>
    </div>
  </div>
</div>

            <div className="modal fade" id="ack" tabIndex="-1" aria-labelledby="ack" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>شكر وتقدير </p>
<p>تم إعداد<i>تتبع التقدم المحرز في مؤشرات أهداف التنمية المستدامة المتعلقة بالأغذية والزراعة لعام 20</i>23 من قبل مكتب كبير الإحصائيين في منظمة الأغذية والزراعة للأمم المتحدة (الفاو)، بالتعاون مع أقسام الإنتاج الحيواني والصحة، والأغذية والتغذية، والتحول الريفي الشامل والمساواة بين الجنسين، ومصايد الأسماك وتربية الأحياء المائية، والغابات، والأراضي والمياه، والأسواق والتجارة، ومكتب تغير المناخ، والتنوع البيولوجي والبيئة، وإنتاج النباتات وحمايتها، والإحصاءات. قاد دوريان نافارو العمل تحت إشراف بيترو جيناري (كبير الإحصائيين). </p>
<p>نود أن نشكر مؤلفي الفصل التالي والمساهمين فيه: روسويثا بومونغ، وريكاردو بيانكالاني، وفيرونيكا بويرو، وإيلين بورغي (منظمة الصحة العالمية - منظمة الصحة العالمية)، وآن برانثوم، وكارلو كافيرو، وبريان كاريزما، وجوليانو كارارا، ومارسيو كاسترو دي سوزا، وكلاوس دينينجر (البنك الدولي)، وخافيير دي لامو، وستيفانو دي كانديا، وستيفانو ديولغيروف، وإليسا دومينغيز (منظمة الصحة العالمية)، وكارولا فابي، ونيكول فرانز، وجيوفانا جاتيكا دومينغيز (منظمة الصحة العالمية)، ويونكا غوربوزر، وتشيكا هاياشي (منظمة الأمم المتحدة للطفولة)، وبريدجيت هولمز، وإيرين هوفمان، وآيا إيديميتسو، روبرت جونستون (اليونيسيف)، وتايلند جوفينال، ويوشيتو كاواكاتسو (اليونيسيف)، وكلارا عايدة خليل، وآن كيبل، وأرباب أسفنديار خان، وجوليا كراسيفيتش (اليونيسيف)، وريتشارد كومابلي (منظمة الصحة العالمية)، وأوليفييه لافاني، وأودون ليم، وغريغوار ليروي، ودان ليسكين، وبييرو مانيني، وشارون ماساخوي مايينغا، وباتريشيا ميخياس مورينو، وجورجيوس ميرميغكاس، وروبرت ندينغا (برنامج الأمم المتحدة للمستوطنات البشرية)، وكلارا بارك، وبول راسيونزر، وجولي روي (أمانة اتفاقية التنوع البيولوجي)، وستيفانيا سافوري، راهول سينغوبتا، (مكتب الأمم المتحدة للحد من مخاطر الكوارث)، وريشي شارما، وتانيا شارما، وجونغ أون سون، ومارك تاكونيت، وفرانشيسكو نيكولا توبييلو، ومونيكا كريسيل وفلوريس أوروتيا (منظمة الصحة العالمية)، وموريل فيليان وسارة فيفياني وفراس ياسين. </p>
<p>قدم فرع المنشورات والمكتبة في مكتب الاتصالات التابع لمنظمة الأغذية والزراعة تصميمًا وتخطيطًا للطبعات بجميع اللغات الست.</p>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">نهاية</button>
                        </div>
                    </div>
                </div>
            </div>



            <NavMain acknowledgements="شكر وتقدير" logo={require('./images/fao-logo.svg').default} copyright="تنويه حول حقوق النشر" scroll="انتقل إلى أعلى" />



            <div
                className={`${transitionStage} ${direction}`}
                onAnimationEnd={() => {
                    if (transitionStage === "fadeOut") {
                        setTransistionStage("fadeIn");
                        setDisplayLocation(location);
                        if (location.state != null) {
                            setOrder(location.state.order);
                        }
                    }
                    document.body.scrollTo({ top: 0, left: 0 })
                }}
            >
                <div className='main'>
                    <Routes location={displayLocation}>
                        <Route  path="/" element={<Home />} />
                        <Route path="/1" element={<Sdg1 />} />
                        <Route path="/2" element={<Sdg2 />} />
                        <Route path="/5" element={<Sdg5 />} />
                        <Route path="/6" element={<Sdg6 />} />
                        <Route path="/10" element={<Sdg10 />} />
                        <Route path="/12" element={<Sdg12 />} />
                        <Route path="/14" element={<Sdg14 />} />
                        <Route path="/15" element={<Sdg15 />} />
                        <Route path="/sdg-indicator-framework" element={<FrameworkAgendaSection />} />
                        <Route path="/annex" element={<Annex />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default function App() {
    return (
        <div className="App">
            <HashRouter>
                <NavEx />
                <AnimatedSwitch />
            </HashRouter>
        </div>
    );
}
